import React from "react";
import { useState, useSelector, useEffect,useImperativeHandle } from 'react';
import panelexp from '../Resources/panelexp.png';
import panelclose from '../Resources/panelclose.png';
import IconButton from '@material-ui/core/IconButton';
import { isEnabled, isEmpty } from '../modules/appLibrary';

export default function GridPanelControl(props) {
    const [max, setmax] = useState(false);

    //useImperativeHandle(ref, () => ({
    //    maximize(value) {
    //        setmax(value);
    //    },
    //}))

    useEffect(() => {
        if (isEmpty(props.gridmaximize)) return;
        if (isEmpty(props.gridmaximize.current)) return;
        if (props.id in props.gridmaximize.current) {
            setmax(isEnabled(props.gridmaximize.current[props.id]));
        }
    }, [props.gridmaximize]);

    function ChangeMax() {
        props.fnc.current.gridmaximize(props.id, !max);
        setmax(!max);
        if (!isEmpty(props.ValueChanged)) {
            props.ValueChanged(props.id, !max);
        }
    }
    return (
        <IconButton size="small" onClick={ChangeMax}  >
            <img src={max ? panelclose : panelexp} style={{ height: 20 }} title={max ? "元に戻す" : "最大化"} alt="" />
        </IconButton>
    );
}